import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {

  public htmlEditorText = `<div class="lessonText">
	<p>David also commanded the chiefs of the Levites to appoint their kindred as the singers to play on musical instruments, on harps and lyres and cymbals, to raise loud sounds of joy. The singers Heman, Asaph, and Ethan were to sound bronze cymbals; Zechariah, Aziel, Shemiramoth, Jehiel, Unni, Eliab, Maaseiah, and Benaiah were to play harps according to Alamoth; but Mattithiah, Eliphelehu, Mikneiah, Obed-edom, Jeiel, and Azaziah were to lead with lyres according to the Sheminith. Chenaniah, leader of the Levites in music, was to direct the music, for he understood it. Berechiah and Elkanah were to be gatekeepers for the ark. Shebaniah, Joshaphat, Nethanel, Amasai, Zechariah, Benaiah, and Eliezer, the priests, were to blow the trumpets before the ark of God. Obed-edom and Jehiah also were to be gatekeepers for the ark.</p>
	<p>So David and the elders of Israel, and the commanders of the thousands, went to bring up the ark of the covenant of the <span class="lordSmallCaps">Lord</span> from the house of Obed-edom with rejoicing. So all Israel brought up the ark of the covenant of the <span class="lordSmallCaps">Lord</span> with shouting, to the sound of the horn, trumpets, and cymbals, and made loud music on harps and lyres.</p>
</div>`;

 
  constructor() { }

  ngOnInit() {
  }

  public valueChanged(e) {
    //console.log("valueChanged", e);
  }

  
}
